import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "data"];
import React from 'react';
import { FieldTypography } from './FieldTypography';
export const FieldData = _ref => {
  let {
    children,
    data
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FieldTypography, _extends({
    color: "textSecondary"
  }, props), data || children);
};